import api from "lib/api/api";

export const FETCH_COURSE_TREE_REQUEST = "FETCH_COURSE_TREE_REQUEST";
export const FETCH_COURSE_TREE_SUCCESS = "FETCH_COURSE_TREE_SUCCESS";
export const FETCH_COURSE_TREE_FAILURE = "FETCH_COURSE_TREE_FAILURE";

export const fetchCourseTree = () => async (dispatch) => {
  dispatch({ type: FETCH_COURSE_TREE_REQUEST });
  try {
    const response = await api.get(`/teachers/course-tree`);
    dispatch({ type: FETCH_COURSE_TREE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_COURSE_TREE_FAILURE, payload: error.message });
  }
};
